import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from '../../../utils/createSignedRequest';

export const updateUserEmployerBusinessIdResourcesFromOrientationForm = async (params) => {
  console.log("updateUserEmployerBusinessIdResourcesFromOrientationForm ~ params:", params)

  const apiPath = `resources/${params.projectId}/update-user-employerbusinessid-resources-from-orientation-form`;

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params), // aws4 looks for body; axios for data
    data: params,
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
